import React, { Component } from 'react'
import Routes from './Routes'
import './utils/formsy-validations'

class App extends Component {
  render () {
    return (
      <Routes />
    )
  }
}

export default App
